export const containerStyle = {
  overflow: "hidden",
  width: "100%",
  height: "94vh",
  boxShadow: 6,
  borderRadius: 5,
  marginLeft: { xs: "20px", md: "45px" },
  marginRight: { xs: "20px", md: "65px" },
  marginTop: "40px",
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
};
export const financialInfo2 = {
  marginTop: { xs: "3vh", md: "24px" },
  fontSize: { xs: "2vh", md: "2.3vh", xl: "20px", xxl: "26px" },
  textAlign: "center",
};
export const volverButton = {
  padding: 1,
  height: { xs: "30px", md: "40px" },
  color: "#2a4886",
  width: "9%",
  marginLeft: "10px",
};
export const volverText = {
  fontSize: { xs: "14px", md: "16px" },
  fontWeight: "bold",
  color: "white",
};
export const nameText = {
  padding: 1,
  fontSize: "3vh",
  width: "15%",
  textAlign: "center",
};
export const priceText = {
  padding: 1,
  fontSize: "3vh",
  fontWeight: "bold",
  width: "20%",
  textAlign: "center",
};
export const variacionText = {
  padding: 1,
  fontSize: "3vh",
  width: "20%",
  textAlign: "center",
};
export const capText = {
  padding: 1,
  fontSize: "3vh",
  width: "25%",
  textAlign: "center",
};
export const separadorStyle = {
  marginRight: "70px",
  marginLeft: "70px",
  color: "lightgray",
  border: 1,
};
export const box2Financial = {
  display: "flex",
  flexDirection: "row",
  marginTop: "20px",
  alignItems: "center",
  marginBottom: "20px",
};
export const boxCardMedia = {
  height: 120,
  width: 280,
  padding: 1,
  marginRight: "40px",
  marginLeft: "40px",
  display: { xs: "none", md: "block" },
};
export const descriptionText = {
  color: "black",
  fontSize: { xs: "1.94vh", md: "2.2vh", lg: "2.3vh" },
  marginRight: { xs: "30px", md: "80px" },
  marginLeft: { xs: "30px", md: "0px" },
  textAlign: "justify",
};
export const box3Financial = {
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  marginBottom: 1.2,
};
export const boxChart = {
  width: "55%",
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  marginTop: "0px",
  marginLeft: "30px",
  alignItems: "center",
  justifyContent: "center",
};
export const separador2Style = {
  marginBottom: "50px",
  marginTop: "60px",
  color: "lightgray",
  border: 1,
};
export const boxRatios = {
  width: { xs: "100%", md: "45%" },
  display: "flex",
  flexDirection: "column",
  marginTop: "10px",
  marginRight: { md: "30px" },
};
export const ratiosText = {
  marginTop: 0,
  fontSize: { xs: "2.4vh", md: "14px", lg: "20px", xl: "24px", xxl: "32px" },
  fontWeight: "bold",
  marginBottom: { xs: "0px", md: "2vh", xl: "4vh" },
  color: "#2a4886",
  textAlign: "center",
};
export const box2Ratios = { display: "flex", flexDirection: "row" };
export const priceText2 = {
  padding: 1,
  fontSize: "2.8vh",
  fontWeight: "bold",
  width: "60%",
  textAlign: "center",
};
export const variacionText2 = {
  padding: 1,
  fontSize: "2.8vh",
  width: "40%",
  textAlign: "center",
};
export const boxMobileStyle = {
  display: { xs: "flex", md: "none" },
  flexDirection: "row",
  alignItems: "center",
  marginBottom: "0px",
};
export const boxCardMedia2 = {
  height: "10vh",
  width: "30vh",
  padding: 1,
  mr: "2vh",
};
export const volverButton2 = {
  padding: 1,
  height: "5.4vh",
  color: "#2a4886",
  borderRadius: 4,
  mr: "2vh",
};

export const boxContenedorAnalisis = {
  width: { xs: "100%", md: "70%" }, 
  display:"flex",
  marginLeft:"20px",
  alignItems:"space-between",
  justifyContent:"space-between",
  alignContent:"center"
};

export const boxAnalisis = {
  display:"flex",
  flexDirection:"column", 
  alignItems:"center",
};

export const priceStyle = {
  margin: "0.5vh",
  fontSize: { xs: "14px", md: "18px", lg: "20px" },
  textAlign: "center",
  marginLeft: { xs: "3vw", sm: "0vw", md: "0vw" },
  marginRight: { xs: "3vw", sm: "0vw" },
};

export const containerDatos = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  alignContent: "center",
  width: "100%",
  height: "50%",
  marginBottom: { xs: 1, sm: 1, md: "none" },
};

export const boxPriceFullScreen = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
};